import BeautyForm from "@/components/BeautyForm";

const Index = () => {
  return <BeautyForm />;
};

export default Index;
